<template>
  <div class="filtrate">
    <el-dialog :visible.sync="dialogVisible" width="90%" :show-close="false">
      <div class="header">
        <div class="font-bold font-22-30313a">客户<span class="font-22-ff5555">{{detail.name}}</span>资料详情</div>
        <i class="el-icon-close close"  @click="onClose"></i>
      </div>
      <div class="content">
        <div class="ptb-20 bg-ff plr-40">
          <div class="flex">
            <div class="flex-1 justify-start">
              <div class="flex-column text-left">
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('salesmanName,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">业务员</div>{{detail.customerAssign.salesmanName ? detail.customerAssign.salesmanName : '-'}}</div>
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('salesmanDepartmentName,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">业务部门</div>{{detail.customerAssign.salesmanDepartmentName ? detail.customerAssign.salesmanDepartmentName : '-'}}</div>
              </div>
            </div>
            <div class="flex-1 justify-start">
              <div class="flex-column text-left">
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('designerName,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">设计师</div>{{detail.customerAssign.designerName ? detail.customerAssign.designerName : '-'}}</div>
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('designerDepartmentName,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">设计部门</div>{{detail.customerAssign.designerDepartmentName ? detail.customerAssign.designerDepartmentName : '-'}}</div>
              </div>
            </div>
            <div class="flex-1 justify-start">
              <div class="flex-column text-left">
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('cmName,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">客户经理</div>{{detail.customerAssign.cmName ? detail.customerAssign.cmName : '-'}}</div>
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('cmDepartmentName,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">客服部门</div>{{detail.customerAssign.cmDepartmentName ? detail.customerAssign.cmDepartmentName : '-'}}</div>
              </div>
            </div>
            <div class="flex-1 justify-start">
              <div class="flex-column text-left">
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('beName,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">预算员</div>{{detail.customerAssign.beName ? detail.customerAssign.beName : '-'}}</div>
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('beDepartmentName,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">预算部门</div>{{detail.customerAssign.beDepartmentName ? detail.customerAssign.beDepartmentName : '-'}}</div>
              </div>
            </div>
            <div class="flex-1 justify-start">
              <div class="flex-column text-left">
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('pmName,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">项目经理</div>{{detail.customerAssign.pmName ? detail.customerAssign.pmName : '-'}}</div>
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('suName,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">工程监理</div>{{detail.customerAssign.suName ? detail.customerAssign.suName : '-'}}</div>
              </div>
            </div>
            <div class="flex-1 justify-start">
              <div class="flex-column text-left">
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('suDepartmentName,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">工程部门</div>{{detail.customerAssign.suDepartmentName ? detail.customerAssign.suDepartmentName : '-'}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="ptb-20 bg-f3f4f7 plr-40">
          <div class="flex">
            <div class="flex-1 justify-start">
              <div class="flex-column text-left">
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('name,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">客户姓名</div>{{detail.name ? detail.name : '-'}}</div>
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('gender,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">性别</div>{{detail.gender=== 0 ? '男': '女'}}</div>
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('spareTelephone,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">备用电话</div>{{detail.spareTelephone ? detail.spareTelephone : '-'}}</div>
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('customerSource,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">客户来源</div>{{detail.customerSource ? detail.customerSource : '-'}}</div>
              </div>
            </div>
            <div class="flex-1 justify-start">
              <div class="flex-column text-left">
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('priority,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">客户级别</div>{{detail.priority ? detail.priority : '-'}}</div>
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('customerType,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">客户类型</div>{{detail.customerType ? detail.customerType : '-'}}</div>
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('customerFocus,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">客户关注</div>{{detail.customerFocus ? detail.customerFocus : '-'}}</div>
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('industryUnderstanding,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">行业了解</div>{{detail.industryUnderstanding ? detail.industryUnderstanding : '-'}}</div>
              </div>
            </div>
            <div class="flex-1 justify-start">
              <div class="flex-column text-left">
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('houseType,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">房屋类型</div>{{detail.houseType ? detail.houseType : '-'}}</div>
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('homeType,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">户型</div>{{detail.homeType ? detail.homeType : '-'}}</div>
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('buildingArea,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">建筑面积</div>{{detail.buildingArea ? detail.buildingArea : '-'}}</div>
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('usingArea,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">使用面积</div>{{detail.usingArea ? detail.usingArea : '-'}}</div>
              </div>
            </div>
            <div class="flex-1 justify-start">
              <div class="flex-column text-left">
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('decorationStyle,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">装修风格</div>{{detail.decorationStyle ? detail.decorationStyle : '-'}}</div>
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('expectationCost,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">期望造价</div>{{detail.expectationCost ? detail.expectationCost : '-'}}</div>
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('location,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">所在方位</div>{{detail.location ? detail.location : '-'}}</div>
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('residentialDistrict,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">楼盘小区</div>{{detail.residentialDistrict ? detail.residentialDistrict : '-'}}</div>
              </div>
            </div>
            <div class="flex-2 justify-start">
              <div class="flex-column text-left">
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('deliveryTime,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">交房时间</div>{{detail.deliveryTime ? Utils.formatDate(detail.deliveryTime) : '-'}}</div>
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('estimateTime,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">预计上门</div>{{detail.estimateTime ? Utils.formatDate(detail.estimateTime) : '-'}}</div>
                <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('detailedAddress,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">详细地址</div>{{detail.detailedAddress ? detail.detailedAddress : '-'}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="ptb-20 bg-ff mlr-40 flex" >
          <div class="flex-1 flex justify-start align-center">
            <div class="flex mr-10"><img src="/static/images/customer/hetonglei.png" class="icon-30" alt=""></div>
            <div class="flex-column text-left">
              <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('budgetEstimateNumber,') > -1" style="opacity: 0.88"><div class="font-12-85 mr-10 ">概算合同号</div>{{detail.budgetEstimateNumber ? detail.budgetEstimateNumber : '-'}}</div>
              <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('budgetContractTime,') > -1" style="opacity: 0.88"><div class="font-12-85 mr-10 ">概算合同签订时间</div>{{detail.budgetContractTime ? Utils.formatDate(detail.budgetContractTime) : '-'}}</div>
            </div>
          </div>
          <div class="flex-1 justify-start">
            <div class="flex-column text-left" style="opacity: 0.88">
              <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('projectContractNo,') > -1"><div class="font-12-85 mr-10 ">施工合同号</div>{{detail.projectContractNo ? detail.projectContractNo : '-'}}</div>
              <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('constructionContractTime,') > -1"><div class="font-12-85 mr-10 ">施工合同签订时间</div>{{detail.constructionContractTime ? Utils.formatDate(detail.constructionContractTime) : '-'}}</div>
            </div>
          </div>
          <div class="flex-1 justify-start">
            <div class="flex-column text-left">
              <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('subContractNo,') > -1"><div class="font-12-85 mr-10 ">分包合同号</div>{{detail.subContractNo ? detail.subContractNo : '-'}}</div>
              <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('subContractTime,') > -1"><div class="font-12-85 mr-10 ">分包合同签订时间</div>{{detail.subContractTime ? Utils.formatDate(detail.subContractTime) : '-'}}</div>
            </div>
          </div>
        </div>
        <div class="ptb-20 bg-ff mlr-40 flex"  style="border-top: 1px dashed #e2e2e2;">
          <div class="flex-1 flex justify-start align-center">
            <div class="flex mr-10"><img src="/static/images/customer/jiagelei.png" class="icon-30" alt=""></div>
            <div class="flex-column text-left">
              <div class="font-16-30313a flex h-17" v-if="keyStr.indexOf('budgetEstimateAmount,') > -1" style="opacity: 0.88"><div class="font-12-85 mr-10 ">概算金额：</div><span class="font-bold">{{detail.budgetEstimateAmount ? detail.budgetEstimateAmount : '-'}}</span></div>
              <div class="font-16-30313a flex h-17" v-if="keyStr.indexOf('frontMoneyAmount,') > -1" style="opacity: 0.88"><div class="font-12-85 mr-10 ">定金金额：</div><span class="font-bold">{{detail.frontMoneyAmount ? detail.frontMoneyAmount : '-'}}</span></div>
            </div>
          </div>
          <div class="flex-1 justify-start">
            <div class="flex-column text-left" style="opacity: 0.88">
              <div class="font-16-30313a flex h-17" v-if="keyStr.indexOf('budgetEstimateAmount,') > -1"><div class="font-12-85 mr-10 ">预算金额：</div><span class="font-bold">{{detail.budgetEstimateAmount ? detail.budgetEstimateAmount : '-'}}</span></div>
              <div class="font-16-30313a flex h-17" v-if="keyStr.indexOf('settlementAmount,') > -1"><div class="font-12-85 mr-10 ">结算金额：</div><span class="font-bold">{{detail.settlementAmount ? detail.settlementAmount : '-'}}</span></div>
            </div>
          </div>
          <div class="flex-1 justify-start">
            <div class="flex-column text-left">
              <div class="font-16-30313a flex h-17" v-if="keyStr.indexOf('subBudget,') > -1"><div class="font-12-85 mr-10 ">分包预算：</div><span class="font-bold">{{detail.subBudget ? detail.subBudget : '-'}}</span></div>
              <div class="font-16-30313a flex h-17" v-if="keyStr.indexOf('subSettlement,') > -1"><div class="font-12-85 mr-10 ">分包结算：</div><span class="font-bold">{{detail.subSettlement ? detail.subSettlement : '-'}}</span></div>
            </div>
          </div>
        </div>
        <div class="ptb-20 bg-ff plr-40 flex"  style="border-top: 1px solid #e2e2e2;padding-bottom: 40px">
          <div class="flex-1 justify-start">
            <div class="flex-column text-left">
              <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('contractFinishTime,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">计划完工时间：</div>{{detail.contractFinishTime ? Utils.formatDate(detail.contractFinishTime) : '-'}}</div>
              <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('actualStartTime,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">实际开工时间：</div>{{detail.actualStartTime ? Utils.formatDate(detail.actualStartTime): '-'}}</div>
              <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('actualEndTime,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">实际完工时间：</div>{{detail.actualEndTime ? Utils.formatDate(detail.actualEndTime) : '-'}}</div>
            </div>
          </div>
          <div class="flex-1 justify-start">
            <div class="flex-column text-left" style="opacity: 0.88">
              <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('afterSalesNumber,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">保修卡编号:</div>{{detail.afterSalesNumber ? detail.afterSalesNumber : '-'}}</div>
              <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('afterSalesStartTime,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">售后开始时间：</div>{{detail.afterSalesStartTime ? Utils.formatDate(detail.afterSalesStartTime): '-'}}</div>
              <div class="font-12-30313a flex h-17" v-if="keyStr.indexOf('afterSalesEndTime,') > -1"><div class="font-12-b9b9b9 mr-10 w-min-47">后结束时间：</div>{{detail.afterSalesEndTime ? Utils.formatDate(detail.afterSalesEndTime) : '-'}}</div>
            </div>
          </div>
          <div class="flex-1 justify-start"></div>
        </div>
      </div>
      <div class="diwen"><img src="/static/images/customer/diwen.png" class="icon-241-37" alt=""></div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'Detail',
  props: ['detail', 'processKey'],
  data () {
    return {
      dialogVisible: true,
      keyStr: ''
    }
  },
  created () {
    this.axios.post('customerInterface/listStr', {companyId: this.$store.state.companyId, processKey: this.processKey}).then(res => {
      if (res.data.success) {
        this.keyStr = res.data.data
      } else {
        this.$message({
          message: '设置所辖公司失败: ' + res.data.msg,
          type: 'error',
          offset: 400
        })
      }
    })
  },
  mounted () {},
  methods: {
    onClose () {
      this.$parent.detailShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .filtrate /deep/ .el-dialog__wrapper{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .filtrate /deep/ .el-dialog{
    border-radius: 6px;
    margin: 0!important;
    max-height: 100%;
    height: auto;
  }
  .filtrate /deep/ .el-dialog__header{
    display: none;
  }
  .filtrate /deep/ .el-dialog__body{
    padding: 0;
    display: flex;
    flex-direction: column;
  }
  .header{
    border-bottom:1px solid #e2e2e2;
    padding: 14px;
    position: relative;
  }
  .close{
    color: #30313a;
    font-size: 22px;
    font-weight: bold;
    position: absolute;
    top:10px;
    right: 10px;
  }
  .content{
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }
  .w-min-47{
    min-width: 47px;
    text-align:justify;
  }
  .w-min-47:after {
    content: " ";
    display: inline-block;
    width: 100%;
  }
  .h-17{
    height: 17px;
  }
  .icon-241-37{
    width: 241px;
    height: 37px;
  }
  .diwen{
    position: absolute;
    bottom: 40px;
    right: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/components/Detail.vue